import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useQuoteBasket } from "@/contexts/QuoteBasketContext";
import { FileText, X } from "lucide-react";

/**
 * Floating bar that appears once a couple has selected venues to request quotes from.
 */
export const QuoteBasketBar = () => {
  const { items, clear } = useQuoteBasket();
  const navigate = useNavigate();
  const location = useLocation();

  if (items.length === 0) return null;
  if (location.pathname.startsWith("/request-quotes")) return null;

  return (
    <div className="fixed inset-x-0 bottom-20 md:bottom-6 z-40 px-4 pointer-events-none">
      <div className="pointer-events-auto mx-auto max-w-2xl rounded-2xl border bg-card shadow-lg p-3 flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-muted flex items-center justify-center shrink-0">
          <FileText className="h-5 w-5 text-primary" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium leading-tight">
            {items.length}{" "}
            {items.every((i) => (i.type || "venue") === "venue")
              ? items.length === 1
                ? "venue"
                : "venues"
              : items.length === 1
                ? "supplier"
                : "suppliers"}{" "}
            selected
          </p>
          <p className="text-xs text-muted-foreground truncate">
            {items.map((i) => i.name).join(", ")}
          </p>
        </div>
        <Button size="sm" onClick={() => navigate("/request-quotes")}>
          Request quotes
        </Button>
        <Button
          size="icon"
          variant="ghost"
          aria-label="Clear selection"
          onClick={clear}
          className="shrink-0"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
